import React, { useMemo } from 'react';
import {
  Grid,
  TextField,
} from '@mui/material';

const formInputStyle = {
  '& .MuiOutlinedInput-root': {
    borderRadius: '10px',
    transition: 'all 0.2s ease-in-out',
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: '#7522D1',
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: '#7522D1',
      borderWidth: '2px',
    },
  },
  '& .MuiInputLabel-root.Mui-focused': {
    color: '#7522D1',
  },
};

const SocialMediaLinks = ({ formData, handleInputChange, errors = {}, touched = {} }) => {
  const validateField = (fieldName, value) => {
    const validators = {
      linkedin: (val) => {
        if (val && !/^(https?:\/\/)?(www\.)?linkedin\.com\/.+/.test(val)) {
          return 'Please enter a valid LinkedIn URL';
        }
        return null;
      },
      twitter: (val) => {
        if (val && !/^(https?:\/\/)?(www\.)?(twitter\.com|x\.com)\/.+/.test(val)) {
          return 'Please enter a valid Twitter/X URL';
        }
        return null;
      },
      facebook: (val) => {
        if (val && !/^(https?:\/\/)?(www\.)?facebook\.com\/.+/.test(val)) {
          return 'Please enter a valid Facebook URL';
        }
        return null;
      },
      instagram: (val) => {
        if (val && !/^(https?:\/\/)?(www\.)?instagram\.com\/.+/.test(val)) {
          return 'Please enter a valid Instagram URL';
        }
        return null;
      },
      youtube: (val) => {
        if (val && !/^(https?:\/\/)?(www\.)?(youtube\.com|youtu\.be)\/.+/.test(val)) {
          return 'Please enter a valid YouTube URL';
        }
        return null;
      }
    };

    return validators[fieldName] ? validators[fieldName](value) : null;
  };

  const fieldErrors = useMemo(() => {
    const errs = {};
    Object.keys(formData).forEach(key => {
      if (touched[key]) {
        const error = validateField(key, formData[key]);
        if (error) errs[key] = error;
      }
    });
    return errs;
  }, [formData, touched]);

  return (
    <Grid container spacing={3}>
      <Grid item size={{ xs: 12, md: 6 }}>
        <TextField
          fullWidth
          label="LinkedIn"
          value={formData.linkedin}
          onChange={(e) => handleInputChange('linkedin', e.target.value)}
          variant="outlined"
          size="small"
          placeholder="https://linkedin.com/company/yourcompany"
          error={!!errors.linkedin || !!fieldErrors.linkedin}
          helperText={errors.linkedin || fieldErrors.linkedin}
          sx={formInputStyle}
        />
      </Grid>
      <Grid item size={{ xs: 12, md: 6 }}>
        <TextField
          fullWidth
          label="Twitter/X"
          value={formData.twitter}
          onChange={(e) => handleInputChange('twitter', e.target.value)}
          variant="outlined"
          size="small"
          placeholder="https://twitter.com/yourcompany"
          error={!!errors.twitter || !!fieldErrors.twitter}
          helperText={errors.twitter || fieldErrors.twitter}
          sx={formInputStyle}
        />
      </Grid>

      <Grid item size={{ xs: 12, md: 6 }}>
        <TextField
          fullWidth
          label="Facebook"
          value={formData.facebook}
          onChange={(e) => handleInputChange('facebook', e.target.value)}
          variant="outlined"
          size="small"
          placeholder="https://facebook.com/yourcompany"
          error={!!errors.facebook || !!fieldErrors.facebook}
          helperText={errors.facebook || fieldErrors.facebook}
          sx={formInputStyle}
        />
      </Grid>
      <Grid item size={{ xs: 12, md: 6 }}>
        <TextField
          fullWidth
          label="Instagram"
          value={formData.instagram}
          onChange={(e) => handleInputChange('instagram', e.target.value)}
          variant="outlined"
          size="small"
          placeholder="https://instagram.com/yourcompany"
          error={!!errors.instagram || !!fieldErrors.instagram}
          helperText={errors.instagram || fieldErrors.instagram}
          sx={formInputStyle}
        />
      </Grid>

      <Grid item size={{ xs: 12 }}>
        <TextField
          fullWidth
          label="YouTube"
          value={formData.youtube}
          onChange={(e) => handleInputChange('youtube', e.target.value)}
          variant="outlined"
          size="small"
          placeholder="https://youtube.com/yourcompany"
          error={!!errors.youtube || !!fieldErrors.youtube}
          helperText={errors.youtube || fieldErrors.youtube}
          sx={formInputStyle}
        />
      </Grid>
    </Grid>
  );
};

export default SocialMediaLinks;
